import { useCallback, useContext, useState } from 'react';
import { MdPauseCircleFilled, MdPlayCircleFilled } from 'react-icons/md';
import YouTube, { Options } from 'react-youtube';
import { ThemeContext } from 'styled-components';
import nextIcon from '../../assets/icons/next.svg';
import prev from '../../assets/icons/prev.svg';
import { useVideoPlayer } from '../../contexts/videoPlayer';
import Divider from '../Divider';
import * as UI from './styles';
import { YoutubePlayer } from './types';
import getYouTubeID from 'get-youtube-id';

export type VideoPlayerConfig = {
  labelPrevius?: string,
  labelNext?: string,
  opts?: Options
}

type PropsVideoPlayer = {
  stateChange?: (event: { target: YoutubePlayer, data: number }, current: { url: string }) => void,
  config?: VideoPlayerConfig;
}

function VideoPlayer({ stateChange, config }: PropsVideoPlayer) {
  const optsAux = {
    height: '450',
    width: '100%',
    playerVars: {
      autoplay: 0,
      controls: 1,
    },
  } as Options;

  const opts = { ...optsAux, ...config?.opts }

  const { current, next, previus, hasNext, hasPrevius } = useVideoPlayer();
  const { colors } = useContext(ThemeContext);

  const [isPlay, setIsPlay] = useState(false);
  const [player, setPlayer] = useState<YoutubePlayer>({} as YoutubePlayer);

  function togglePlay() {
    setIsPlay(!isPlay);

    if (!isPlay) {
      player.playVideo();
    } else {
      player.pauseVideo();
    }
  }

  const handleStateChange = useCallback((event: { target: YoutubePlayer, data: number }, current: { url: string }) => {
    if (stateChange) {
      return stateChange(event, current);
    }
  }, [stateChange]);

  return (
    <UI.Container>
      <span>{current.name}</span>
      {!!current && !!current.url && <YouTube
        videoId={getYouTubeID(current.url) ?? ''}
        containerClassName="container-videoPlayer"
        id="player"
        title={current.name}
        opts={opts}
        onReady={ev => setPlayer(ev.target)}
        onPlay={() => setIsPlay(true)}
        onPause={() => setIsPlay(false)}
        onStateChange={(event) => handleStateChange(event, current)}
      />}
      <UI.Controls>
        <span className={!hasPrevius() ? 'disabled' : ''} onClick={() => previus()}>{config?.labelPrevius ?? 'Anterior'}</span>
        <img className={!hasPrevius() ? 'disabled' : ''} onClick={() => previus()} src={prev} alt="Back time" />
        <Divider h="2rem" w={0} />
        {isPlay ? (
          <MdPauseCircleFilled
            size={36}
            color={colors.white}
            onClick={togglePlay}
            cursor="pointer"
          />
        ) : (
          <MdPlayCircleFilled
            size={36}
            color={colors.white}
            onClick={togglePlay}
            cursor="pointer"
          />
        )}
        <Divider h="2rem" w={0} />
        <img className={!hasNext() ? 'disabled' : ''} onClick={() => next()} src={nextIcon} alt="Advance time" />
        <span className={!hasNext() ? 'disabled' : ''} onClick={() => next()}>{config?.labelNext ?? 'Próximo'}</span>
      </UI.Controls>
    </UI.Container>
  );
}

export default VideoPlayer;
